var React = require('react');

function SocialX (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Twitter"),React.createElement("path",{"d":"M7.03163 7L12.0508 13.706L7 19.1583H8.13682L12.5589 14.3846L16.1316 19.1583H20L14.6983 12.0752L19.3996 7H18.2628L14.1905 11.3963L10.9 7H7.03163ZM8.70337 7.83667H10.4805L18.328 18.3217H16.5509L8.70337 7.83667Z","fill":"white","key":1})]);
}

SocialX.defaultProps = {"width":"27","height":"27","viewBox":"0 0 27 27","fill":"none"};

module.exports = SocialX;

SocialX.default = SocialX;
